import { z } from "zod";
import { paginationResponseType } from "@/types";

// ============ GET VISITORS ============
export const searchVisitorSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(50).default(10)
});

export type visitorResponseType = {
    id: string;
    sequence: number;
    name: string;
    email: string | null;
    observation: string | null;
    createdAt: string;
    updatedAt: string;
    receiveNotifications: boolean;
};

export type VisitorsResponse = {
    data: visitorResponseType[];
    pagination: paginationResponseType;
};

export const defaultVisitor: visitorResponseType = {
    id: '',
    sequence: 0,
    name: '',
    email: '',
    observation: null,
    createdAt: '',
    updatedAt: '',
    receiveNotifications: false
};

// ============ UPDATE VISITOR ============
export type UpdateVisitorType = {
    id: string;
    name?: string | undefined;
    email?: string | undefined;
    observation?: string | undefined;
    receiveNotifications: boolean;
};

export type VisitorIdResponseType = {
    id: string;
    name: string;
    email: string | undefined;
    observation: string | undefined;
    receiveNotifications: boolean;
};

export type VisitorStateInfo = {
    success?: boolean;
    message?: string;
    errors?: {
        id?: string[];
        name?: string[];
        email?: string[];
        observation?: string[];
        receiveNotifications?: string[];
    };
    values?: {
        id: string;
        name?: string;
        email?: string;
        observation?: string;
        receiveNotifications?: string;
    };
};

export const UpdateDefaultVisitor: VisitorIdResponseType = {
    id: '',
    name: '',
    email: '',
    observation: '',
    receiveNotifications: false,
};

export const updateVisitorSchema = z.object({
    id: z.uuid(),
    name: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    email: z.string().optional(),
    observation: z.string().optional(),
    receiveNotifications: z.boolean().default(false).optional()
});

// ============ TIPOS COMPLETOS ============
export type VisitorResponse = {
    id: string;
    sequence: number;
    name: string;
    email: string | '';
    observation: string | '';
    receiveNotifications: boolean;
    createdAt: string;
    updatedAt: string | null;
};

export type VisitorCreateResponse = {
    svt25: string;
    visitorId: string;
};

export type VisitorMeResponse = {
    name: string;
    email: string;
};

export type VisitorUpdateResponse = {
    svt25: string;
    success: boolean;
};

// ============ CREATE VISITOR ============
export type CreateVisitorType = {
    name: string;
    email?: string;
    receiveNotifications?: boolean;
};

export type CreateVisitorState = {
    success?: boolean;
    message?: string;
    errors?: {
        name?: string[];
        email?: string[];
        receiveNotifications?: string[];
    };
    values?: CreateVisitorType;
};

// ============ TIPOS PARA FORMULÁRIOS ============
export type VisitorFormData = {
    name: string;
    email?: string;
    observation?: string;
    receiveNotifications?: boolean;
};